var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.78 2H8.22C4.44 2 3.5 3.01 3.5 7.04V18.3C3.5 20.96 4.96 21.59 6.73 19.69L6.74 19.68C7.56 18.81 8.81 18.88 9.52 19.83L10.53 21.18C11.34 22.25 12.65 22.25 13.46 21.18L14.47 19.83C15.19 18.87 16.44 18.8 17.26 19.68C19.04 21.58 20.49 20.95 20.49 18.29V7.04C20.5 3.01 19.56 2 15.78 2ZM9 7C9.55 7 10 7.45 10 8C10 8.55 9.56 9 9 9C8.44 9 8 8.55 8 8C8 7.45 8.44 7 9 7ZM15 14C14.44 14 14 13.55 14 13C14 12.45 14.45 12 15 12C15.55 12 16 12.45 16 13C16 13.55 15.56 14 15 14ZM15.9 7.59L9.17 14.32C9.02 14.47 8.83 14.54 8.64 14.54C8.45 14.54 8.26 14.47 8.11 14.32C7.82 14.03 7.82 13.55 8.11 13.26L14.84 6.53C15.13 6.24 15.61 6.24 15.9 6.53C16.19 6.82 16.19 7.3 15.9 7.59Z",
    fill: "#D03660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponIcon);
export default __webpack_public_path__ + "static/media/coupon-icon.5648d54f3818a711484e3a3c0da6ad93.svg";
export { ForwardRef as ReactComponent };